import { takeEvery, put, fork } from "redux-saga/effects";
import * as actions from "../actions/LocalizationDataActions";
import * as api from "../../api/LocalizationDataApi";
import moment from "moment";
import { setBackdrop, resetBackdrop } from "../actions/BackdropActions";
import { showSuccessSnackbar, showErrorSnackbar } from "../actions/SnackbarActions";

function* getExcelList(action) {
    yield put(resetBackdrop());
    try {
        console.log(action);
        if (action.payload.tabId == 0) {
            console.log("BreakdownDetail saga");
            const { data } = yield api.postBreakdownDetailExcelToList(action.payload.data);
            yield put(actions.setExcelList(data || undefined));
        } else if (action.payload.tabId == 1) {
            console.log("BreakdownEffect saga");
            const { data } = yield api.postBreakdownEffectExcelToList(action.payload.data);
            yield put(actions.setExcelList(data || undefined));
        } else if (action.payload.tabId == 2) {
            console.log("BreakdownReasonGroup saga");
            const { data } = yield api.postBreakdownReasonGroupExcelToList(action.payload.data);
            yield put(actions.setExcelList(data || undefined));
        } else if (action.payload.tabId == 3) {
            console.log("BreakdownReasonPlace saga");
            const { data } = yield api.postBreakdownReasonPlaceExcelToList(action.payload.data);
            yield put(actions.setExcelList(data || undefined));
        } else if (action.payload.tabId == 4) {
            console.log("BreakdownRootCause saga");
            const { data } = yield api.postBreakdownRootCauseExcelToList(action.payload.data);
            yield put(actions.setExcelList(data || undefined));
        }
    } catch (error) {
        console.log(error);
        yield put(showErrorSnackbar(error, "error"));
    }
    yield put(setBackdrop());
}

function* postExcelUpload(action) {
    yield put(resetBackdrop());
    try {
        if (action.payload.tabId == 0) {
            const { data } = yield api.postBreakdownDetailExcelUpload(action.payload.data);
            yield put(actions.postExcelUpload(data || undefined));
            yield put(showSuccessSnackbar(data.message));
        } else if (action.payload.tabId == 1) {
            const { data } = yield api.postBreakdownEffectExcelUpload(action.payload.data);
            yield put(actions.postExcelUpload(data || undefined));
            yield put(showSuccessSnackbar(data.message));
        } else if (action.payload.tabId == 2) {
            const { data } = yield api.postBreakdownReasonGroupExcelUpload(action.payload.data);
            yield put(actions.postExcelUpload(data || undefined));
            yield put(showSuccessSnackbar(data.message));
        } else if (action.payload.tabId == 3) {
            const { data } = yield api.postBreakdownReasonPlaceExcelUpload(action.payload.data);
            yield put(actions.postExcelUpload(data || undefined));
            yield put(showSuccessSnackbar(data.message));
        } else if (action.payload.tabId == 4) {
            const { data } = yield api.postBreakdownRootCauseExcelUpload(action.payload.data);
            yield put(actions.postExcelUpload(data || undefined));
            yield put(showSuccessSnackbar(data.message));
        }
    } catch (error) {
        yield put(showErrorSnackbar(error));
    }
    yield put(setBackdrop());
}

function* downloadExcelFile(action) {
    yield put(resetBackdrop());
    try {
        let { data } = {};
        let name = "";
        console.log(action.payload)
        if (action.payload.tabId == 0) {
            data = yield api.downloadBreakdownDetailExcel();
            name = "BreakdownDetail";
        } else if (action.payload.tabId == 1) {
            data = yield api.downloadBreakdownEffectExcel();
            name = "BreakdownEffect";
        } else if (action.payload.tabId == 2) {
            data = yield api.downloadBreakdownReasonGroupExcel();
            name = "BreakdownReasonGroup";
        } else if (action.payload.tabId == 3) {
            data = yield api.downloadBreakdownReasonPlaceExcel();
            name = "BreakdownReasonPlace";
        } else if (action.payload.tabId == 4) {
            data = yield api.downloadBreakdownRootCauseExcel();
            name = "BreakdownRootCause";
        }
        console.log("data: ", data);
        if (name != "") {
            const url = window.URL.createObjectURL(new Blob([data.data]));
            const link = document.createElement("a");
            link.href = url;
            const filename = "MOST_" + name + "_" + moment(new Date()).format("DD_MM_YYYY_HH_mm_ss") + ".xlsx"; //name with date time & extension
            link.setAttribute("download", filename); //or any other extension
            document.body.appendChild(link);
            link.click();
        }
    } catch (error) {
        yield put(showErrorSnackbar(error));
    }
    yield put(setBackdrop());
}

function* watchAll() {
    yield takeEvery(actions.Types.GET_EXCEL_LIST, getExcelList);
    yield takeEvery(actions.Types.LOCALIZATION_UPLOAD_FILE, postExcelUpload);
    yield takeEvery(actions.Types.LOCALIZATION_EXCEL_FILE_OUTLINE, downloadExcelFile);
}

const LocalizationDataSaga = [fork(watchAll)];

export default LocalizationDataSaga;
